import * as React from "react";

import { Apps28Filled, Apps28Regular } from "@fluentui/react-icons";

import { TeamAppConfig } from "Apps/TeamAppModel";

const PathfinderApp = React.lazy(async () => {
    const namedExport = await import(/* webpackChunkName: "Pathfinder" */ "./PathfinderApp");
    return { default: namedExport.PathfinderApp };
});

export const Pathfinder: TeamAppConfig = {
    title: "Pathfinder",
    regularIcon: Apps28Regular,
    filledIcon: Apps28Filled,
    description: "Pathfinder is a tool to identify and resolve Sovereign Cloud service blockers.",
    team: "ONR",
    publicId: "SKUMAPPINGBRIDGE\\Triage", // Pathfinder's IcM oncall rotation is owned by the SKU Mapping team, confirmed with Angel Arroyo
    owner: "SKUMapBridgeAdmin@microsoft.com",
    role: "*",
    tags: [],
    app: PathfinderApp,
    path: "/Pathfinder",
    hiddenFromSearch: true
};
